import _ from 'lodash';

import React from 'react';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import WithUser from 'shared/HOCs/WithUser';

import { openModal } from 'shared/components/Modals/reducer';

import { HOME_URL, MODALS } from 'global-constants';

const LoginRequired = (WrappedComponent, modalName = MODALS.SIGNUP) => {
  class HOC extends React.Component {
    componentDidMount() {
      const { user } = this.props;

      if (_.isEmpty(user)) {
        this.props.push(
          `${HOME_URL}?next=${this.props.match.url +
            this.props.location.search}`
        );

        const modalToOpen = _.get(this.props, 'modalName', modalName);
        this.props.openModal({ modalName: modalToOpen });
      }
    }

    render() {
      const { match, user, fetchingUser, ...rest } = this.props;
      if (user) {
        return <WrappedComponent match={match} {...rest} />;
      }
      return null;
    }
  }

  const mapDispatchToProps = {
    openModal,
    push
  };

  return withRouter(
    WithUser(
      connect(
        null,
        mapDispatchToProps
      )(HOC)
    )
  );
};

export default LoginRequired;
